/* My Acre default variant preselect (2026-08-11, Claude).
   Why: Shopify derives the pre-selected variant from OPTION VALUE ORDER, so the only
   native way to land on a non-first combination is to reorder the option values, which
   drags the sizes out of ascending order (2.5m, 3.0m, 3.5m, 4.0m). This picks the
   landing combination on the client instead, so option order stays natural AND the page
   opens on the configuration we actually sell most of.
   Reads window.MA_DEFAULT_OPTIONS (set per product from the custom.default_options
   metafield, pipe separated, e.g. "3.0m Square|Heron Black|Oyster").
   Skipped entirely when the URL already carries ?variant= so ad, Google Shopping and
   shared deep links always win. Progressive enhancement: fails silently. */
(function () {
  function run() {
    try {
      var wanted = window.MA_DEFAULT_OPTIONS;
      if (!wanted) return;
      if (new URLSearchParams(window.location.search).has('variant')) return;

      var container = document.querySelector('[data-product-options-container]');
      if (!container) return;
      if (container.dataset.maDefaultApplied) return;

      var values = String(wanted).split('|').map(function (v) { return v.trim(); }).filter(Boolean);
      if (!values.length) return;

      var inputs = container.querySelectorAll('.ma-option-value__input');
      if (!inputs.length) return;

      /* Resolve every requested value BEFORE changing anything, so a renamed or retired
         option value can never leave the picker half set and unbuyable. */
      var targets = [];
      values.forEach(function (val) {
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].value === val) { targets.push(inputs[i]); break; }
        }
      });
      if (targets.length !== values.length) return;

      container.dataset.maDefaultApplied = '1';

      /* Fire change on EACH input, not just the last one. The theme's chosen-value
         labels and the buy-box recap each read event.target, so a single event would
         update the price and image but leave the visible labels showing stale values. */
      targets.forEach(function (input) {
        if (!input.checked) input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    } catch (e) { /* never block the page */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 60); });
  } else {
    setTimeout(run, 60);
  }
})();
